import { render, staticRenderFns } from "./ManagePermissionEditor.vue?vue&type=template&id=8102eff0&scoped=true&"
import script from "./ManagePermissionEditor.vue?vue&type=script&lang=js&"
export * from "./ManagePermissionEditor.vue?vue&type=script&lang=js&"
import style0 from "./ManagePermissionEditor.vue?vue&type=style&index=0&id=8102eff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8102eff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
  VSelect,
  VTextField,
})
